/* eslint-disable consistent-return */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import countriesOptions from '@/mixins/countriesOptions';
import DraftData from '@/components/draft-data';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import Validations from '@/mixins/validations';

export default {

    /**
     * Nombre del componente
     */
    name: 'ContactData',

    components: {
        DraftData
    },

    mixins: [
        Validations,
        countriesOptions,
        formatData,
        keyed
    ],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            collapsed: true,
            contactEdit: false,
            searchOptions: [],
            formatDataRules: () => ({
                'key_mobile_phone_prefix': [ value => (value ? { phone_prefix: value } : null) ],
                'key_home_phone_prefix': [ value => (value ? { phone_prefix: value } : null) ],
                'key_work_phone_prefix': [ value => (value ? { phone_prefix: value } : null) ],
                'key_other_phone_prefix': [ value => (value ? { phone_prefix: value } : null) ],
                'contact_language': [ value => ( value ? { key: value, name: this.$t(`contactLanguages.${value}`) } : null) ]
            })
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        data: {
            type: Object,
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {


        /**
         * Load search country options
         * @param {String} input search parameter
         */
        searchCountry(input) {
            this.searchOptions = this.countriesOptions
                .filter(x => (x.name.toLowerCase().concat(x.phone_prefix))
                    .includes(input.toLowerCase()));
        },

        /**
         * Load contact language options
         */
        loadContactLanguageOptions() {
            const contactLanguages = this.$t(`contactLanguages`, { returnObjects: true });
            this.contactLanguageOptions = Object.keys(contactLanguages).map(key => {
                return { key, name: contactLanguages[key] };
            });
        },

        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        editContact(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.contactEdit = edit;
            if (edit) {
                if (!this.collapsed) {
                    this.$root.$emit('bv::toggle::collapse', 'collapse-2');
                    this.modifiedData = {};
                }
            } else {
                this.formatData();
                this.modifiedData = {};
            }
        },

        /**
         * Label de busqueda del multiselect
         * @param {*} country option
         * @return {String} Customlabel
         */
        customPrefixLabel(country) {
            return `${country.name} ${country.prefix}`;
        },

        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            switch (field) {
                case 'key_mobile_phone_prefix':
                case 'key_home_phone_prefix':
                case 'key_work_phone_prefix':
                    this.modifiedData[field] = val.phone_prefix;
                    break;
                default:
                    this.modifiedData[field] = typeof val === 'object'
                        ? val.key
                        : val;
                    break;
            }
        },

        validateData() {
            this.cleanErrors();
          
            const requiredProperties = ['email', 'mobile_phone'];
            return Promise.resolve(true)
              .then(valid => this.validateRequired(requiredProperties, valid));
        },        

        /**
         * @override
         */
        onSubmit(e) {
            e.preventDefault();
            if (this.modifiedData['mobile_phone'] && this.modifiedData['mobile_phone'].trim() === '') {
                this.modifiedData['mobile_phone'] = null;
            }

            if(this.modifiedData['key_mobile_phone_prefix'] && this.modifiedData['key_mobile_phone_prefix'].trim() === ''){
                this.modifiedData['key_mobile_phone_prefix'] = null
            }

            this.$intervenersService
                .updateIntervenerInfo(this.uuid, this.modifiedData )
                .then(res => {
                    this.$toast.success(res.result.http_code, res.result.info);
                    this.contactEdit = false;
                    this.$root.$emit('refresh_intervener');
                })
                .catch(err => {
                    this.$toast.error(err.name, err.message);
                    this.modifiedData = {};
                    this.contactEdit = false;
                });
        }
    },

    computed: {
        /**
         * Lista de prefijos ordenada alfabéticamente
         * @return {*} Listado
         */
        countriesPrefixOptions() {
            return this.countriesOptions
                .filter(x => !!x.phone_prefix)
                .sort((a, b) => a.name > b.name);
        }
    },

    /**
     * @override
     */
    beforeMount() {
        if (this.creation) {
            this.contactEdit = !this.existing;
        }
        this.loadContactLanguageOptions();
    }
};
